module.exports = __webpack_public_path__ + "img/img_quick_alssl.c3c5a47a.jpg";